__turbopack_context__.v({
  "accessory": "productDetail-module__UHNh9G__accessory",
  "actionMessage": "productDetail-module__UHNh9G__actionMessage",
  "actions": "productDetail-module__UHNh9G__actions",
  "backLink": "productDetail-module__UHNh9G__backLink",
  "breadcrumb": "productDetail-module__UHNh9G__breadcrumb",
  "cartButton": "productDetail-module__UHNh9G__cartButton",
  "chips": "productDetail-module__UHNh9G__chips",
  "commentComposer": "productDetail-module__UHNh9G__commentComposer",
  "commentHeader": "productDetail-module__UHNh9G__commentHeader",
  "commentItem": "productDetail-module__UHNh9G__commentItem",
  "commentList": "productDetail-module__UHNh9G__commentList",
  "commentPager": "productDetail-module__UHNh9G__commentPager",
  "craftChips": "productDetail-module__UHNh9G__craftChips",
  "description": "productDetail-module__UHNh9G__description",
  "designer": "productDetail-module__UHNh9G__designer",
  "detailGrid": "productDetail-module__UHNh9G__detailGrid",
  "disabledCartButton": "productDetail-module__UHNh9G__disabledCartButton",
  "galleryStrip": "productDetail-module__UHNh9G__galleryStrip",
  "heroImage": "productDetail-module__UHNh9G__heroImage",
  "lockedText": "productDetail-module__UHNh9G__lockedText",
  "lower": "productDetail-module__UHNh9G__lower",
  "mockOnly": "productDetail-module__UHNh9G__mockOnly",
  "optionBlock": "productDetail-module__UHNh9G__optionBlock",
  "optionChip": "productDetail-module__UHNh9G__optionChip",
  "optionChipActive": "productDetail-module__UHNh9G__optionChipActive",
  "optionChipDisabled": "productDetail-module__UHNh9G__optionChipDisabled",
  "page": "productDetail-module__UHNh9G__page",
  "preview": "productDetail-module__UHNh9G__preview",
  "previewCube": "productDetail-module__UHNh9G__previewCube",
  "previewMeta": "productDetail-module__UHNh9G__previewMeta",
  "previewSwitch": "productDetail-module__UHNh9G__previewSwitch",
  "previewThumb": "productDetail-module__UHNh9G__previewThumb",
  "previewThumbActive": "productDetail-module__UHNh9G__previewThumbActive",
  "price": "productDetail-module__UHNh9G__price",
  "productRenderCanvas": "productDetail-module__UHNh9G__productRenderCanvas",
  "productRenderViewer": "productDetail-module__UHNh9G__productRenderViewer",
  "purchasePanel": "productDetail-module__UHNh9G__purchasePanel",
  "quantity": "productDetail-module__UHNh9G__quantity",
  "readOnlyNotice": "productDetail-module__UHNh9G__readOnlyNotice",
  "related": "productDetail-module__UHNh9G__related",
  "relatedGrid": "productDetail-module__UHNh9G__relatedGrid",
  "relatedTitle": "productDetail-module__UHNh9G__relatedTitle",
  "storeActions": "productDetail-module__UHNh9G__storeActions",
  "storeBanner": "productDetail-module__UHNh9G__storeBanner",
  "storeCard": "productDetail-module__UHNh9G__storeCard",
  "storeCover": "productDetail-module__UHNh9G__storeCover",
  "storeIntro": "productDetail-module__UHNh9G__storeIntro",
  "thumbs": "productDetail-module__UHNh9G__thumbs",
  "topLine": "productDetail-module__UHNh9G__topLine",
  "wrap": "productDetail-module__UHNh9G__wrap",
});
